import React from 'react'

const Link = (props) => {
    const { children, ...otherProps } = props

    const attr = {
        target: props.target || '_blank',
        rel: 'noopener noreferrer',
        href: props.href || '',
        style: {
            color: '#E8EDED',
            ...(props.style || {}),
        },
        ...otherProps,
    }

    return (
        <a {...attr}>{children}</a>
    )
}

export default Link